'use client';

import { supabase } from '@/lib/supabase/client';

export async function obtenerRolUser(userId: string, tenantId: string) {
  const { data, error } = await supabase
    .schema('app_utils')
    .from('user_roles')
    .select('role_code')
    .eq('user_id', userId)
    .eq('tenant_id', tenantId)
    .single();

  if (error) throw error;
  return data;
}
